const de = {
  name: 'Liste',
  count: 'Anzahl',
  recipients: 'Empfänger',
  edit: 'Liste bearbeiten',
  push: 'Neue Liste',
}
export default de;